import React from 'react';
import {
  useRouteError,
  isRouteErrorResponse,
  useLocation,
} from 'react-router-dom';
import Header from '@amzn/awsui-components-core/header';
import { monitor, logError, METRIC_NAMES } from 'src/utils/monitoring';
import { getMessageFromError } from 'src/utils/helpers';

const RouteErrorBoundary = () => {
  const error = useRouteError();
  const location = useLocation();
  const pathName = location.pathname;

  if (isRouteErrorResponse(error)) {
    logError(error.data.message || error.statusText, {
      route: location.pathname,
    });
  } else {
    logError(getMessageFromError(error), {
      route: location.pathname,
    });
  }

  monitor.count(
    METRIC_NAMES.ROUTE_ERROR_BOUNDARY_ENCOUNTER,
    1,
    { methodName: 'RouteErrorBoundary' },
    { pathName }
  );

  return (
    <Header variant="h1">
      We are experiencing technical difficulty, please check back later
    </Header>
  );
};

export default RouteErrorBoundary;
